import { useStoreActions } from '~/contexts';
import { useMutationState } from '../useMutationState';
import { GenerateServiceDescriptionType } from './useGenerateServiceDescription.types';
export const useGenerateServiceDescription = ()=>{
    const { api } = useStoreActions();
    const { mutateAsync, isPending } = useMutationState({
        mutationFn: async (request)=>{
            switch(request.requestType){
                case GenerateServiceDescriptionType.Title:
                    return api.service.generateDescriptionFromTitle({
                        title: request.title,
                        metadata: {
                            component: request.component || 'service-editor',
                            sourceId: request.serviceId
                        }
                    });
                case GenerateServiceDescriptionType.Description:
                    {
                        if (request.type === 'message') {
                            return api.service.generateDescriptionFromDescription({
                                description: request.description,
                                message: request.message,
                                type: 'message',
                                title: request.title,
                                metadata: {
                                    component: request.component || 'service-editor',
                                    sourceId: request.serviceId
                                }
                            });
                        }
                        return api.service.generateDescriptionFromDescription({
                            description: request.description,
                            preset: request.preset,
                            type: 'preset',
                            title: request.title,
                            metadata: {
                                component: request.component || 'service-editor',
                                sourceId: request.serviceId
                            }
                        });
                    }
                case GenerateServiceDescriptionType.Message:
                    return api.service.generateDescriptionFromMessage({
                        conversationId: request.conversationId,
                        type: 'message',
                        message: request.message
                    });
                case GenerateServiceDescriptionType.Preset:
                    return api.service.generateDescriptionFromPreset({
                        conversationId: request.conversationId,
                        type: 'preset',
                        preset: request.preset
                    });
            }
        },
        withPageLoader: false
    });
    return {
        generateDescription: mutateAsync,
        isLoading: isPending
    };
};
